// #294 redesign — whether a critical alert is sounding in this tab: an open critical event inside its
// sound window and not quieted (each tab works this out itself, even when another tab plays). Set by the
// critical sound controller (useCriticalSound), read by WebSocketProvider: the normal chime is skipped
// meanwhile. A plain module value, so the chime check needs no React.
let sounding = false

export function isCriticalSounding(): boolean {
  return sounding
}

export function setCriticalSounding(on: boolean): void {
  sounding = on
}
